import { gql } from 'react-apollo';
import {
    UPDATE_EDIT_PROFILE_INFO_ERROR,
    UPDATE_EDIT_PROFILE_INFO_START,
    UPDATE_EDIT_PROFILE_INFO_SUCCESS
} from '../../constants';

import showToaster from '../../helpers/showToaster';

export function updateEditProfileInfo({ profileId,
    firstName,
    lastName,
    gender,
    dateOfBirth,
    location,
    info,
    phoneNumber,
    countryCode,
    countryName,
    displayName
}) {

    return async (dispatch, getState, { client }) => {

        dispatch({ type: UPDATE_EDIT_PROFILE_INFO_START })

        try {
            const mutation = gql`
                mutation updateEditProfileInfo(
                $profileId:Int,
                $firstName:String,
                $lastName:String,
                $gender:String,
                $dateOfBirth:String,
                $location:String,
                $info:String,
                $phoneNumber:String,
                $countryName:String,
                $countryCode:String
                ){
                    updateEditProfileInfo(
                    profileId:$profileId,
                    firstName:$firstName,
                    lastName:$lastName,
                    gender:$gender,
                    dateOfBirth:$dateOfBirth,
                    location:$location,
                    info:$info,
                    phoneNumber:$phoneNumber,
                    countryName:$countryName,
                    countryCode:$countryCode
                    ){
                              status
                        }
                    }
            `
            const { data } = await client.mutate({
                mutation,
                variables: {
                    profileId,
                    firstName,
                    lastName,
                    gender,
                    dateOfBirth,
                    location,
                    info,
                    phoneNumber,
                    countryCode,
                    countryName,
                    displayName
                }
            });

            dispatch({ type: data && data?.updateEditProfileInfo?.status === 200 ? UPDATE_EDIT_PROFILE_INFO_SUCCESS : UPDATE_EDIT_PROFILE_INFO_ERROR });
            data && data?.updateEditProfileInfo?.status === 200 ? showToaster({ messageId: 'updateEditProfile', toasterType: 'success' }) : showToaster({ messageId: 'commonError', toasterType: 'error' })

        } catch (error) {
            dispatch({
                type: UPDATE_EDIT_PROFILE_INFO_ERROR
            });
        }

    };
}
